<script lang="ts">
  import ChevronIcon from '$icons/Chevron.svelte';
  import type { ComponentType } from 'svelte';
  import { slide } from 'svelte/transition';
  import ActiveBadge from './badges/ActiveBadge.svelte';
  import PausedBadge from './badges/PausedBadge.svelte';

  export let title: string;
  export let icon: ComponentType;
  export let initiallyExpanded = false;
  export let active: boolean | null = null;

  let expanded = initiallyExpanded;
</script>

<div class="w-full">
  <button
    class="text-gray-dark-11 hover:text-gray-dark-12 flex w-full items-center justify-between px-4 py-2 text-sm font-normal leading-5"
    on:click={() => (expanded = !expanded)}
    class:text-gray-dark-12={expanded}
  >
    <div class="flex items-center gap-x-1.5">
      <svelte:component this={icon} class="h-4 w-4" />
      <span>{title}</span>
    </div>

    {#if active}
      <ActiveBadge />
    {:else if active === false}
      <PausedBadge />
    {/if}

    <div class:rotate-180={expanded}>
      <ChevronIcon />
    </div>
  </button>

  {#if expanded}
    <div
      class="border-gray-dark-3 mx-4 mb-1 flex flex-col gap-1 border-l pl-4"
      transition:slide={{ duration: 300 }}
    >
      <slot />
    </div>
  {/if}
</div>
